import { Line3, Vector3 } from "three";
import { useStoreRoom } from "../useStoreRoom";
import { useStoreSystem } from "../useStoreSystem";
import { SideType, SideTypeWithoutTop, TargetZoomType } from "../types/store";
import { getRoomDepthValueInMeters } from "../../utils/getRoomDepthValue";
/**
 * Функция получает вектор камеры по середине двух векторов
 * @param lineVertices Vector3[] из двух векторов
 * @returns Vector3 - положение камеры
 */
export const getCameraPositionToMiddleLine = (
    lineVertices: Vector3[],
    side?: SideTypeWithoutTop,
    customTargetZoom?: TargetZoomType
) => {
    const proMode = useStoreSystem.getState().proMode;
    const line = new Line3(lineVertices[0], lineVertices[1]);
    const targetZoom = customTargetZoom || useStoreSystem.getState().targetZoom;
    const currentSide = side || useStoreSystem.getState().currentSide;
    const roomLength = useStoreRoom.getState().length / 1000;
    const roomDepth = proMode ? useStoreRoom.getState().depth / 1000 : useStoreRoom.getState().cameraDistance / 1000;
    const targetVector = new Vector3();
    line.getCenter(targetVector);
    const normal = new Vector3()
        .subVectors(lineVertices[1], lineVertices[0])
        .applyAxisAngle(new Vector3(0, 1, 0), Math.PI / 2)
        .normalize();

    const normalVert = [
        //FIXME подумать а точно только от длины комнаты зависит нормальный вектор? (Корнилов)
        normal.clone().setLength(roomLength).add(targetVector),
        normal.clone().setLength(0).add(targetVector),
    ];

    if (targetZoom === "item") {
        return normalVert[0];
    }
    if (targetZoom === "wall") {
        if (currentSide === "front") {
            return new Vector3(targetVector.x, targetVector.y, targetVector.z + roomLength);
        }
        if (currentSide === "back") {
            return new Vector3(targetVector.x, targetVector.y, targetVector.z - roomLength);
        }
        if (currentSide === "left") {
            return new Vector3(targetVector.x + roomDepth, targetVector.y, targetVector.z);
        }
        if (currentSide === "right") {
            return new Vector3(targetVector.x - roomDepth, targetVector.y, targetVector.z);
        }
        if (currentSide === "top") {
            return new Vector3(targetVector.x, targetVector.y + Math.max(roomLength, roomDepth), targetVector.z);
        }
    }
    console.error("getCameraPositionToMiddleLine не вернула вектор положения камеры");
    return normalVert[0];
};
